import { render, staticRenderFns } from "./DialogoBalancos.vue?vue&type=template&id=4e1bb22c&scoped=true&"
import script from "./DialogoBalancos.vue?vue&type=script&lang=js&"
export * from "./DialogoBalancos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1bb22c",
  null
  
)

export default component.exports